var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[(_vm.initialized)?_c('admin-home'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }